<template>
    <v-container max-width="1200">
        <v-card class="pa-4 align-center justify-center">
            <v-card-title>Login</v-card-title>

            <v-card-text>
                <v-form></v-form>
                <v-text-field
                    v-model="email"
                    placeholder="Enter your email address"
                    prepend-inner-icon="mdi-email-outline"
                    :rules="emailRules"
                    variant="outlined"
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    :append-inner-icon="passVisible ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="passVisible ? 'text' : 'password'"
                    placeholder="Enter your password"
                    prepend-inner-icon="mdi-lock-outline"
                    :rules="passwordRules"
                    variant="outlined"
                    @click:append-inner="passVisible = !passVisible"
                ></v-text-field>
                <v-btn
                    size="large"
                    variant="tonal"
                    block
                    @click="login"
                    class="mb-4"
                    :loading="loading"
                    >
                    <!-- :disabled="btnDissabled" -->
                    Log In
                </v-btn>
                <!-- **TODO** Will need to resize for mobile -->
                <v-btn
                    size="large"
                    variant="tonal"
                    block
                    @click="toSignUpPage"
                >
                    Dont Have an Account? Sign Up
                </v-btn>
                <!-- <v-btn
                    size="large"
                    variant="tonal"
                    block
                    @click="ping()"
                >
                    Ping
                </v-btn> -->
                <v-card-text v-if="errorMessage != ''">{{ errorMessage }}</v-card-text>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
// import axios from 'axios'
// import { VDateInput } from 'vuetify/labs/VDateInput'
// import JsonCSV from 'vue-json-csv'
import { useMainStore } from '@/store/store';


export default {
    setup() {
        const store = useMainStore()

        return { store }
    },
    name: 'LoginPage',

    components: {
        // VDateInput,
        // JsonCSV,
    },

    data: () => ({
        email: '',
        password: '',
        passVisible: false,
        errorMessage: '',
        loading: false,

        emailRules: [
            value => {
                if (value) return true

                return 'E-mail is required.'
            },
            value => {
                if (/.+@.+\..+/.test(value)) return true

                return 'E-mail must be valid.'
            },
        ],
        passwordRules: [
            value => {
                if (value) return true

                return 'Password is required.'
            },
        ],
        btnDissabledRules: [
            () => {
                if (this.email && this.password && (/.+@.+\..+/.test(this.email))) return false

                return true
            },
        ],

    }),

    methods: {
        ping(){
            this.store.pingAPI()
        },
        // **TODO Must implement password hashing
        async login() {

            this.loading = true

            if((this.email && this.password && (/.+@.+\..+/.test(this.email))) === false){
                this.errorMessage = "Please enter a valid email and password"
                this.loading = false
                return
            }
            let data = {
                email: this.email,
                password: this.password
            }

            // await console.log('Login data:', data)

            await this.store.login(data)
                .then(() => {
                    this.loading = false
                    // this.$router.go({ path: 'about' })
                    this.$router.push({ path: '/about' })
                    .then(() => {
                        this.$router.go()
                    })
                    // this.setTimeout(() => {
                        
                    // }, timeout);
                    // this.$router.push({ name: 'admin' })
                })
                .catch((error) => {
                    // console.log("Page error:")
                    // console.log(error)
                    this.errorMessage = error.response.data
                    this.loading = false
                })

        //     .then(() => {
            // this.loading = false
            // this.$router.replace({ path: '/' })
        //     })
        //     .catch((error) => {
        //         this.errorMessage = error.message
        //     })
        },
        toSignUpPage(){
            this.$router.push({ name: 'signup' })
        },

    }

}
</script>
